import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './Component/Navbar/Navbar';
import Sidebar from './Component/Sidebar/Sidebar';
import Homepage from './Pages/Homepage/Homepage';
import About from './Pages/About/Aboutpage'; 
import Footer from './Component/Footer/Footer';
import ItemView from './Pages/ItemView/ItemView';
import OfferView from './Pages/OffferView/OfferView';
import NewArrivalView from './Pages/NewArrivalView/NewArrivalView';
import Contact from './Pages/Contact/Contact';
import Service from './Pages/Service/Service';
import DynamicCategory from './Category/DynamicCategory';
import ProductComparison from './Pages/ProductComparison/ProductComparison';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import ReturnPolicy from './Pages/ReturnPolicy/ReturnPolicy';
import TermsAndConditions from './Pages/TermsAndConditions/TermsAndConditions';
import Checkout from './Pages/Checkout/Checkout';
import MaintenancePage from './Pages/MaintenancePage/MaintenancePage';

{/*}
// Maintenance Check Component
function MaintenanceGuard({ children }) {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const baseURL = "https://backendweb.properteck.lk";

  useEffect(() => {
    checkMaintenanceStatus();
    
    // Check maintenance status every 30 seconds
    const interval = setInterval(() => {
      checkMaintenanceStatus();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const checkMaintenanceStatus = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/maintenance/status`, {
        timeout: 5000
      });
      
      if (response.data && response.data.success) {
        setIsMaintenanceMode(response.data.maintenance.enabled);
      }
    } catch (error) {
      console.error('Error checking maintenance status:', error);
      // If API fails, assume maintenance is off
      setIsMaintenanceMode(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Show loading state
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  // If maintenance mode is enabled and user is not on maintenance page
  if (isMaintenanceMode && location.pathname !== '/maintenance') {
    return <Navigate to="/maintenance" replace />;
  }

  // If maintenance mode is disabled and user is on maintenance page
  if (!isMaintenanceMode && location.pathname === '/maintenance') {
    return <Navigate to="/" replace />;
  }

  return children;
}
*/}
// Create a layout component that conditionally renders the sidebar
function AppLayout() {
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  
  const baseURL = window.APP_CONFIG?.API_URL || "https://backendweb.properteck.lk";

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/categories/getcategories`, {
        timeout: 5000
      });
      
      if (response.data) {
        const categoryData = response.data.categories || response.data || [];
        setCategories(Array.isArray(categoryData) ? categoryData : []);
      }
    } catch (error) {
      console.error('Error fetching categories for routes:', error);
    } finally {
      setCategoriesLoaded(true);
    }
  };

  // Define routes where sidebar should be hidden
  const hideSidebarRoutes = ['/privacy-policy', '/return-policy', '/terms-and-conditions', '/checkout', '/maintenance'];
  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);

  // Hide Navbar and Footer on maintenance page
  const isMaintenancePage = location.pathname === '/maintenance';

  return (
    <div className="app">
      {/*<MaintenanceGuard>*/}
        <div className="firstview">
          {isMaintenancePage ? (
            // Render maintenance page directly in firstview
            <Routes>
              <Route path="/maintenance" element={<MaintenancePage />} />
            </Routes>
          ) : (
            // Normal layout with Navbar, Sidebar, and content
            <>
              <Navbar />
              
              <div className="app-content">
                {/* Conditionally render Sidebar */}
                {!shouldHideSidebar && <Sidebar />}
                
                <div className="main-content">
                  <Routes> 
                    {/* Static Routes */}
                    <Route path="/" element={<Homepage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/service" element={<Service />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                    <Route path="/returnpolicy" element={<ReturnPolicy />} />
                    <Route path="/termsconditions" element={<TermsAndConditions />} />
                    <Route path="/item/:id" element={<ItemView />} />
                    <Route path="/offer/:id" element={<OfferView />} />
                    <Route path="/newarrivals/:id" element={<NewArrivalView />} />
                    <Route path="/productComparison" element={<ProductComparison />} />
                    <Route path="/checkout" element={<Checkout />} />
                    
                    {/* Single Dynamic Category Route */}
                    <Route path="/:categoryName" element={<DynamicCategory />} />
                    
                    {/* Fallback route for 404 */}
                    <Route 
                      path="*" 
                      element={
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <h2>Page Not Found</h2>
                          <p>The page you're looking for doesn't exist.</p>
                        </div>
                      } 
                    />
                  </Routes>
                </div>
              </div>
              
              <Footer />
            </>
          )}
        </div>
      {/*</MaintenanceGuard>*/}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;